import { useEffect, useState } from 'react';

export const useSidebarWidth = () => {
    const [sidebarWidth, setSidebarWidth] = useState(0);

    useEffect(() => {
        const sidebar =
            document.querySelector('#kt_app_sidebar') ||
            document.querySelector('#kt_aside');

        if (!sidebar) return;

        const updateWidth = () => {
            setSidebarWidth(sidebar.getBoundingClientRect().width);
        };

        updateWidth();

        const observer = new ResizeObserver(updateWidth);
        observer.observe(sidebar);

        return () => {
            observer.disconnect();
        };
    }, []);

    return sidebarWidth;
};